import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CopySourceRegistryService {
    private readonly _copySourceTypes: string[] = [];

    public register(copySourceType: string): void {
        this._copySourceTypes.push(copySourceType);
    }

    public has(copySourceType: string): boolean {
        return this._copySourceTypes.find((e) => e === copySourceType) != null;
    }
}
